import { useState, useEffect } from "react"
import useClickListener from "../../utils/hooks/useClickListener"
import { containsValidTargetClass } from "./DatalayerMethods"

const DatalayerProductFinder = props => {
  const [relatedSearchClick, setRelatedSearchClick] = useState(false)

  const relatedSearchClickHandler = event => {
    if (
      containsValidTargetClass(
        ["product-finder__search-links--search-link"],
        event?.target?.classList
      )
    ) {
      setRelatedSearchClick(true)
    }
  }

  const searchResetClickHandler = event => {
    if (
      containsValidTargetClass(
        ["product-finder__reset-text"],
        event?.target?.classList
      )
    ) {
      setRelatedSearchClick(false)
    }
  }

  const datalayerProductFinderResultHandler = event => {
    if (
      containsValidTargetClass(
        ["nav-search__hit--link"],
        event?.target?.classList
      )
    ) {
      window.dataLayer = window.dataLayer || []
      let searchFilterText = ""
      document
        .querySelectorAll(".product-finder__filter-active")
        .forEach(filter => {
          searchFilterText = searchFilterText + " " + filter.innerText
        })

      window.dataLayer.push({
        event: "search",
        search_term: document.querySelector(".product-finder__search-box__input")
          .value,
        number_of_results: document
          .querySelector(".product-finder__stats__text")
          ?.innerText?.split(" ")
          .pop()
          .replace(/\(|\)/g, ""),
        search_url_clicked: event.target.href,
        related_search_clicked: relatedSearchClick,
        search_filter: searchFilterText,
        product_finder_search: true,
      })
    }
  }
  // add handler if relevant listener elem exists
  let querySearch = ""
  if (typeof window !== "undefined" && typeof document !== "undefined") {
    querySearch =
      document?.querySelectorAll(".product-finder__search-box__input").length > 0
  }
  useClickListener(datalayerProductFinderResultHandler, querySearch)

  useEffect(() => {
    if (
      typeof window !== "undefined" &&
      typeof document !== "undefined"
    ) {
      const gatsbyApp = document?.getElementById("___gatsby")
      gatsbyApp.addEventListener("click", relatedSearchClickHandler)
      return () => {
        gatsbyApp.removeEventListener("click", relatedSearchClickHandler)
      }
    }
  })

  useEffect(() => {
    if (
      typeof window !== "undefined" &&
      typeof document !== "undefined"
    ) {
      const gatsbyApp = document?.getElementById("___gatsby")
      gatsbyApp.addEventListener("click", searchResetClickHandler)
      return () => {
        gatsbyApp.removeEventListener("click", searchResetClickHandler)
      }
    }
  })

}

export default DatalayerProductFinder